module.exports = __webpack_public_path__ + "img/pin_bear.e0fe39b4.png";